import game1 from '../../asset/images/game-01.jpg'
import game2 from '../../asset/images/game-02.jpg'
import game3 from '../../asset/images/game-03.jpg'


const TopGameCardData = [
    { id: 'G1', image: game1, name: 'Fortnite', kind: 'Sandbox', rate: '4.8', download: '1.8M' },
    { id: 'G2', image: game2, name: 'PubG', kind: 'Battle', rate: '4.9', download: '2.5M' },
    { id: 'G3', image: game3, name: 'CS-GO', kind: 'Legendary', rate: '2.6', download: '4.3M' },
    { id: 'G4', image: game1, name: 'Fortnite', kind: 'Sandbox', rate: '3.5', download: '3.3M' },
]

export default TopGameCardData